import React from 'react';
import cls from './Comment.module.css';
import { useComment } from './useComment';
import { TextArea } from '../../../../../components/newUI/TextArea/TextArea';

export const Comment = () => {
    const { calculations, onInput } = useComment();
    return (
        <div>
            <TextArea
                label={i18next.t('Comment.return.label')}
                inputName={'comment'}
                classes={cls.MeasurementComment}
                value={calculations.comment ? calculations.comment : ''}
                onChange={onInput}
            />
        </div>
    );
};
